import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/app/centervention-logo-white.png';
import styles from './_common.module.sass';

const PublicHeaderLogo = () => <Link to="/">
    <img src={logo} alt="" className={styles.logoWhite}/>
</Link>;

export default PublicHeaderLogo;
